const DomSelectors = {
    body: document.body,
    container: document.getElementById("container"),
    menu: document.querySelector(".menu"),
    search_pokedex: document.querySelector(".search-pokedex")
}

export{DomSelectors}